// import { Route, BrowserRouter as Router, Routes, Navigate, useLocation } from 'react-router-dom';
// import './App.css';
// import Navigationbar from './component/Navigationbar';
// import Home from './pages/Home';
// import Login from './pages/Login';
// import Register from './pages/Register';
// import Passreset from './pages/Passreset';
// import Bomview from './pages/Bomview';
// import { AuthProvider, checkSessionTimeout } from './Auth/AuthProvider';
// import PrivateRoute from './Auth/PrivateRoute';
// import DocApp from './DoctorApp/DocApp';
// import HomeTour from './TourApp/HomeTour';
// import AllGuides from './TourApp/pages/AllGuides';
// import UserProfile from './TourApp/pages/UserProfile';
// import PackageCreate from './TourApp/pages/PackageCreate';
// import PackageSelect from './TourApp/pages/PackageSelect';
// import AgroTechHome from './Agrotech/pages/AgroTechHome';
// import CenterGroup from './Agrotech/pages/ResourceGroup';
// import CenterGroupManagement from './Agrotech/pages/ResourceGroupManagement';
// import RollingHome from './Rolling_Forecast/RollingHome';
// import LodingData from './Rolling_Forecast/LodingData';
// import CenterOperations from './Agrotech/pages/ResourceOperations';
// import AgroTechMainPage from './Agrotech/pages/AgroTechMainPage';
// import Resources from './Agrotech/pages/Resources';
// import ResourceGroup from './Agrotech/pages/ResourceGroup';
// import ManagementResourceGroup from './ResourcesManagement/pages/ManagementResourceGroup';
// import ManagementResources from './ResourcesManagement/pages/ManagementResources';
// import JoinMeeting from './DoctorApp/JoinMeeting';
// import AdminDashbord from './AdminDashbord/AdminDashbord';
// import GuideReg from './TourApp/pages/GuideReg';
// import Usersmanagement from './AdminDashbord/Usersmanagement';
// import CustormerManagement from './AdminDashbord/CustormerManagement';
// import UserRoleManagement from './AdminDashbord/UserRoleManagement';
// import CompanyAccessManagement from './AdminDashbord/CompanyPermissions';
// import { useEffect } from 'react';
// import { Navigate } from 'react-router-dom';



// function App() {
//   return (
//     <Router>
//       <AuthProvider>
//         <Navigationbar />
//         <Routes>
//           {/* Add the following Route at the top */}
//           <Route path="/" element={<Navigate to="/login" replace />} />

//           <Route path="/login" element={<Login />} />
//           <Route
//             path="/admin"
//             element={
//               <PrivateRoute>
//                 <AdminDashbord />
//               </PrivateRoute>
//             }
//           />
//           {/* <Route path="/login" element={<Login />} /> */}
//           <Route path="/docApp" element={<PrivateRoute element={<DocApp />} />} />
//           <Route path="/register" element={<Register />} />
//           <Route path="/password-reset" element={<Passreset />} />
//           <Route path="/bom/:product_id" element={<Bomview />} />
//           {/* <Route path="/homeTour" element={<HomeTour />} /> */}
//           {/* <Route path="/allGuides" element={<AllGuides />} /> */}
//           {/* <Route path="/userProfile/:id" element={<PrivateRoute element={<UserProfile />}/>} /> */}
//           {/* <Route path="/package" element={<PackageCreate />} /> */}
//           {/* <Route path="/packageSelect/:packageId" element={<PackageSelect />} /> */}
//           <Route path="/AgroTechHome" element={<AgroTechHome />} />
//           <Route path="/resourceGroupCreate" element={<ResourceGroup />} />
//           <Route path="/manageResourceGroup" element={<CenterGroupManagement />} />
//           <Route path="/center-operations" element={<CenterOperations />} />
//           <Route path="/rollingHme" element={<RollingHome />} />
//           <Route path="/rollingLodingData" element={<LodingData />} />
//           <Route path="/AgroTechMain" element={<AgroTechMainPage />} />
//           <Route path="/Resources" element={<ManagementResources />} />
//           <Route path="/ManagementResourceGroup" element={<ManagementResourceGroup />} />
//           <Route path="/joinMeeting/:token" element={<PrivateRoute element={<JoinMeeting />} />} />
//           <Route path="/registerGuide" element={<GuideReg />} />
//           <Route path="/userManagement" element={<AdminDashbord><Usersmanagement /></AdminDashbord>} />
//           <Route path="/custormerManagement" element={<AdminDashbord><CustormerManagement /></AdminDashbord>} />
//           <Route path="/userRoleManagement" element={<AdminDashbord><UserRoleManagement /></AdminDashbord>} />
//           <Route path="/permissions" element={<AdminDashbord><CompanyAccessManagement /></AdminDashbord>} />

//         </Routes>
//       </AuthProvider>
//     </Router>
//   );
// }

// export default App;



import { Route, BrowserRouter as Router, Routes, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import Navigationbar from './component/Navigationbar';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Verify2FA from './pages/Verify2FA';
import Passreset from './pages/Passreset';
import Bomview from './pages/Bomview';
import { AuthProvider, checkSessionTimeout } from './Auth/AuthProvider';
import PrivateRoute from './Auth/PrivateRoute';
import DocApp from './DoctorApp/DocApp';
import HomeTour from './TourApp/HomeTour';
import AllGuides from './TourApp/pages/AllGuides';
import UserProfile from './TourApp/pages/UserProfile';
import PackageCreate from './TourApp/pages/PackageCreate';
import PackageSelect from './TourApp/pages/PackageSelect';
import AgroTechHome from './Agrotech/pages/AgroTechHome';
import CenterGroup from './Agrotech/pages/ResourceGroup';
import CenterGroupManagement from './Agrotech/pages/ResourceGroupManagement';
import RollingHome from './Rolling_Forecast/RollingHome';
import LodingData from './Rolling_Forecast/LodingData';
import CenterOperations from './Agrotech/pages/ResourceOperations';
import AgroTechMainPage from './Agrotech/pages/AgroTechMainPage';
import Resources from './Agrotech/pages/Resources';
import ResourceGroup from './Agrotech/pages/ResourceGroup';
import ManagementResourceGroup from './ResourcesManagement/pages/ManagementResourceGroup';
import ManagementResources from './ResourcesManagement/pages/ManagementResources';
import JoinMeeting from './DoctorApp/JoinMeeting';
import AdminDashbord from './AdminDashbord/AdminDashbord';
import GuideReg from './TourApp/pages/GuideReg';
import Usersmanagement from './AdminDashbord/Usersmanagement';
import CustormerManagement from './AdminDashbord/CustormerManagement';
import UserRoleManagement from './AdminDashbord/UserRoleManagement';
import CompanyAccessManagement from './AdminDashbord/CompanyPermissions';
import FirmwareManagement from './AdminDashbord/FirmwareManagement';
import PrivilegeManagement from './AdminDashbord/PrivilegeManagement';
import { useEffect } from 'react';
import { useState, useLayoutEffect } from 'react';
import './App.css';
import Spinner from './component/Spinner'; // Add this import
// ... (rest of your imports remain)

function AppContent() {
  // Spinner for route/page changes
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  useLayoutEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 650); // Simulate loading
    return () => clearTimeout(timer);
  }, [location.pathname]);

  if (loading) return <Spinner />;

  // Your main layout
  return (
    <>
      <Navigationbar />
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/verify-2fa" element={<Verify2FA />} />
        <Route path="/admin" element={
          <PrivateRoute>
            <AdminDashbord />
          </PrivateRoute>
        } />
        <Route path="/docApp" element={<PrivateRoute element={<DocApp />} />} />
        <Route path="/register" element={<Register />} />
        <Route path="/password-reset" element={<Passreset />} />
        <Route path="/bom/:product_id" element={<Bomview />} />
        {/* <Route path="/homeTour" element={<HomeTour />} /> */}
        {/* <Route path="/allGuides" element={<AllGuides />} /> */}
        {/* <Route path="/userProfile/:id" element={<PrivateRoute element={<UserProfile />}/>} /> */}
        {/* <Route path="/package" element={<PackageCreate />} /> */}
        {/* <Route path="/packageSelect/:packageId" element={<PackageSelect />} /> */}
        <Route path="/AgroTechHome" element={<AgroTechHome />} />
        <Route path="/resourceGroupCreate" element={<ResourceGroup />} />
        <Route path="/manageResourceGroup" element={<CenterGroupManagement />} />
        <Route path="/center-operations" element={<CenterOperations />} />
        <Route path="/rollingHme" element={<RollingHome />} />
        <Route path="/rollingLodingData" element={<LodingData />} />
        <Route path="/AgroTechMain" element={<AgroTechMainPage />} />
        <Route path="/Resources" element={<ManagementResources />} />
        <Route path="/ManagementResourceGroup" element={<ManagementResourceGroup />} />
        <Route path="/joinMeeting/:token" element={<PrivateRoute element={<JoinMeeting />} />} />
        <Route path="/registerGuide" element={<GuideReg />} />
        <Route path="/userManagement" element={<AdminDashbord><Usersmanagement /></AdminDashbord>} />
        <Route path="/custormerManagement" element={<AdminDashbord><CustormerManagement /></AdminDashbord>} />
        <Route path="/userRoleManagement" element={<AdminDashbord><UserRoleManagement /></AdminDashbord>} />
        <Route path="/permissions" element={<AdminDashbord><CompanyAccessManagement /></AdminDashbord>} />
        <Route path="/firmwareManagement" element={<AdminDashbord><FirmwareManagement /></AdminDashbord>} />
        <Route path="/privilegeManagement" element={<AdminDashbord><PrivilegeManagement /></AdminDashbord>} />
      </Routes>
    </>
  );
}


function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
